import { useRef, useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import JsBarcode from "jsbarcode";
import html2canvas from "html2canvas";
import Barcode from "react-barcode";

export default function GiftCard() {
  const { t } = useTranslation();
  window.document.title = `${t("Panda")}`;

  const cardRef = useRef(null);
  const barcodeRef = useRef(null);

  const [barcodeImageUrl, setBarcodeImageUrl] = useState("");

  const { campaign_id, barcode: barcodeValue } = useParams();
  const giftCardImageUrl = "/images/strategic_partner_flat.png";

  useEffect(() => {
    console.log("User Agent:", navigator.userAgent);
    if (barcodeRef.current) {
      JsBarcode(barcodeRef.current, barcodeValue, {
        format: "CODE128",
        ean128: false,
        lineColor: "#000",
        width: 2,
        height: 60,
        fontSize: 14,
        flat: true,
        displayValue: true,
        background: "#eee",
      });
    }
  }, [barcodeValue]);

  const handleDownload = () => {
    if (cardRef.current) {
      html2canvas(cardRef.current, { useCORS: true, logging: true }).then(
        (canvas) => {
          const image = canvas.toDataURL("image/png", 1.0);
          const link = document.createElement("a");
          link.href = image;
          link.download = "gift-card.png";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      );
    }
  };

  return (
    <>
      <div className="container my-5 d-flex flex-column flex-lg-row gap-5">
        <div className="d-flex flex-column gap-3 flex-grow-1">
          <div
            ref={cardRef}
            title="Download Card"
            onClick={handleDownload}
            className="d-flex justify-content-end align-items-end position-relative gift-card-container"
          >
            <div className="barcode-container">
              <img
                ref={barcodeRef}
                alt="Barcode"
                className="barcode-container"
              />
              {/* <Barcode
                value={barcodeValue}
                fontOptions="bold"
                background="#06251b"
                lineColor="#eee"
                // width={1.7}
                // height={100}
              /> */}
            </div>
          </div>
          <button
            title="Download Card"
            onClick={handleDownload}
            className="download-gift-card-btn"
          >
            تحميل
            <i className="bi bi-download" style={{ marginLeft: "15px" }}></i>
          </button>
        </div>
        <div className="gift-card-terms">
          <div class="row">
            <div class="col-md-12">
              <div class="card">
                <div class="card-header d-flex justify-content-between">
                  <div class="card-title text-right">Terms & Conditions</div>
                  <div class="card-title text-right">الشروط والأحكام</div>
                </div>

                <div class="card-body">
                  <ul class="card-text">
                    <li>
                      The card is valid for one year from the date of issuance.
                    </li>
                    <li>
                      Panda Company has the right to change the benefits or
                      suspend or cancel the card at any time without referring
                      back to the customer.
                    </li>
                  </ul>
                  <hr />
                  <p class="card-text text-right">
                    <li>البطاقة صالحة لمدة عام من تاريخ الإصدار.</li>
                    <li>
                      لشركة بنده الحق في تغيير المزايا أو تعليق البطاقة أو
                      إلغائها في أي وقت دون الرجوع إلى العميل.
                    </li>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
